import React from "react";
import styles from "./Inputs.module.scss";
import { Controller } from "react-hook-form";
import Input from "../Input/Input";
import { InputFieldProps } from "./types";
import { API_DATE_FORMAT, INPUT_TIME_FORMAT } from "Shared/Constants/app";
import { format } from "Shared/Utils/shared";

const InputField = (props: InputFieldProps) => {
  const {
    withController = false,
    control,
    name,
    defaultValue,
    error = null,
    labelColor,
    downLabel,

    valueNullable = false,
    type,
  } = props;

  const { label = false, required = false, ...restProps } = props;

  delete restProps.withController;

  function getDefaultValueAccordingToType() {
    const currentDateTime = new Date();

    if (type === "date" && valueNullable) {
      return null;
    }

    if (type === "date") {
      return format(currentDateTime, API_DATE_FORMAT);
    } else if (type === "time") {
      return format(currentDateTime, INPUT_TIME_FORMAT);
    } else {
      return defaultValue;
    }
  }
  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    if (type === "number") {
      e.preventDefault();
    }
  };

  return (
    <div className={styles.inputs}>
      {label && (
        <label
          style={{ color: labelColor }}
          data-id={name}
          className={styles.inputs__label}
        >
          {label}
          {required && <span className={styles.inputs__error}>*</span>}
        </label>
      )}
      {withController ? (
        <Controller
          control={control}
          name={name}
          defaultValue={getDefaultValueAccordingToType()}
          render={({ field, fieldState }) => (
            <>
              <Input
                {...field}
                {...restProps}
                required={required}
                ref={field.ref}
                onWheel={handleWheel}
                onChange={(event) => {
                  field.onChange(event);
                  props.onChange?.(event);
                }}
                variant="standard"
              />
              {fieldState.error && (
                <div className={styles.inputs__error}>
                  {fieldState.error.message}
                </div>
              )}
            </>
          )}
        />
      ) : (
        <>
          <Input {...restProps} ref={null} variant="standard" />
          {error && <div className={styles.inputs__error}>{error}</div>}
        </>
      )}
      {downLabel && (
        <span data-id={name} className={styles.inputs__downlabel}>
          {downLabel}
        </span>
      )}
    </div>
  );
};
export default InputField;
